import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireStaff } from "@/common/routes/requireStaff";

export const Route = createFileRoute("/app/admin")({
  beforeLoad: ({ context }) => {
    requireStaff(context);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
